import { FC } from 'react'

import { HeaderSkeleton } from '@revolut-internal/ui-kit'

type QueueHealthPolicySkeletonProps = {
  onBack: VoidFunction
}

export const QueueHealthPolicySkeleton: FC<QueueHealthPolicySkeletonProps> = ({
  onBack,
}) => {
  return (
    <HeaderSkeleton>
      <HeaderSkeleton.BackButton onClick={onBack} />
      <HeaderSkeleton.Title />
      <HeaderSkeleton.Subtitle />
    </HeaderSkeleton>
  )
}
